import Vue from 'vue';

window.Vue = Vue;

import axios from 'axios'

window.axios = axios;

import interact from 'interactjs';

window.interact = interact;

Vue.component('dashboard', require('../js/components/dashboard').default);

Vue.component('sticker-manager', require('../js/components/stickerManager').default);
Vue.component('banner-manager', require('../js/components/bannerManager').default);

Vue.component('sale', require('../js/components/sale').default);

Vue.component('groups', require('../js/components/groups').default);
Vue.component('vouchers', require('../js/components/vouchers').default);



window.app = new Vue({
    el: '#app',
})